import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/button';
import { Checkbox } from './ui/checkbox';

const DisclaimerPopup = ({ onAccept }) => {
  const [isChecked, setIsChecked] = useState(true);
  const [isVisible, setIsVisible] = useState(true);

  const handleProceed = () => {
    setIsVisible(false);
    setTimeout(() => {
      onAccept();
    }, 300);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', backdropFilter: 'blur(8px)' }}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', duration: 0.5 }}
            className="bg-white rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
          >
            <div className="p-8">
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#1A1A1A' }}>
                Disclaimer
              </h2>
              <div className="text-base leading-relaxed mb-6" style={{ color: '#555555' }}>
                <p className="mb-4">
                  The Bar Council of India does not permit advertisement or solicitation by 
                  advocates in any form or manner. By accessing this website, you acknowledge 
                  and confirm that you are seeking information relating to NamoriSatya Legal 
                  of your own accord and that there has been no form of solicitation, 
                  advertisement or inducement by NamoriSatya Legal or its members.
                </p>
                <p className="mb-4">
                  The content of this website is for informational purposes only and should not be 
                  interpreted as soliciting or advertisement. No material/information provided 
                  on this website should be construed as legal advice.
                </p>
                <p>
                  NamoriSatya Legal shall not be liable for consequences of any action taken by 
                  relying on the material/information provided on this website.
                </p>
              </div>
              <div className="flex items-center space-x-3 mb-6">
                <Checkbox 
                  id="accept" 
                  checked={isChecked} 
                  onCheckedChange={setIsChecked}
                  className="border-2"
                />
                <label 
                  htmlFor="accept" 
                  className="text-sm font-medium cursor-pointer"
                  style={{ color: '#1A1A1A' }}
                >
                  I accept the above.
                </label>
              </div>
              <Button
                onClick={handleProceed}
                disabled={!isChecked}
                variant="outline"
                className="w-full text-base font-semibold py-6 transition-all duration-300"
                style={{ 
                  borderColor: '#2B2BFF', 
                  color: '#2B2BFF',
                  borderWidth: '2px'
                }}
              >
                PROCEED TO WEBSITE
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DisclaimerPopup;